





const ChargesRateTable=({extracts})=>{

    if (extracts?.length === 0) {
        return (
          <div className="row">
            <div className="col-xs-12 table-responsive">
              <h1></h1>
            </div>
          </div>
        );
      } else {
        return (
          <div className="row" style={{ marginTop: 30, marginLeft: 10 }}>
            <div className="col-xs-12 table-responsive">
              <p className="lead">Les charges :</p>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Libelle</th>
                    <th>Montant</th>
                  </tr>
                </thead>
  
                <tbody>
                  {extracts &&
                    extracts.map((extrat) => (
                      <tr key={extrat.rate.id}>
                        <td>{extrat.rate?.code}-{extrat.rate?.name}</td>
                        <td>{extrat.price}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      }




}

export default ChargesRateTable;